import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-placements-create',
  templateUrl: './placements-create.component.html',
  styleUrls: ['./placements-create.component.scss']
})
export class PlacementsCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  coursename = null;
  submitted = false;
  public placementsForm: FormGroup;
  public courses = [];

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/placementsbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.placementsForm.patchValue({
              _id: data.data._id,
              course: data.data.course,
              coursename: data.data.coursename,
              company: data.data.company,
              logoalt: data.data.logoalt,
              hiringfor: data.data.hiringfor,
              name: data.data.name,
              review: data.data.review,
              designation: data.data.designation,
              sector: data.data.sector,
              seohidden: data.data.seohidden
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });
    

    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
        data => {
          this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });

    this.placementsForm = this.formBuilder.group({
      course: ['', Validators.required],
      company: ['', Validators.required],
      coursename: '',
      hiringfor: '',
      name: '',
      review: '',
      designation: '',
      sector: '',
      logoalt: ['', Validators.required],
      _id: [''],
      seohidden: ['']
    })
  }
  
  getcourses(value){
    this.http.get<any>(this.api_endpoint+'/coursebyid/'+value).subscribe(
      data => {
        
        this.placementsForm.patchValue({
          coursename: data.data.course,
        })
       
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  get f() { return this.placementsForm.controls; }

  onFormSubmit() {

    this.submitted = true;

    if (this.placementsForm.invalid) {
      // alert();
      return;
    }

    
      // alert(this.action);
    if(this.action == 'Submit'){

      

    var data = {
      "course" : this.placementsForm.value.course,
      "coursename" : this.placementsForm.value.coursename,
      "company" : this.placementsForm.value.company,
      "logoalt" : this.placementsForm.value.logoalt,
      "hiringfor" : this.placementsForm.value.hiringfor,
      "name" : this.placementsForm.value.name,
      "review" : this.placementsForm.value.review,
      "designation" : this.placementsForm.value.designation,
      "sector" : this.placementsForm.value.sector,
      "admin" : sessionStorage.getItem('adminName'),
      "seohidden" : this.placementsForm.value.seohidden
    };

    
    this.http.post<any>(this.api_endpoint+'/placements', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/recruiters/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
    }else{
      var data1 = {
        "course" : this.placementsForm.value.course,
        "coursename" : this.placementsForm.value.coursename,
        "company" : this.placementsForm.value.company,
        "logoalt" : this.placementsForm.value.logoalt,
        "hiringfor" : this.placementsForm.value.hiringfor,
        "name" : this.placementsForm.value.name,
        "review" : this.placementsForm.value.review,
        "designation" : this.placementsForm.value.designation,
        "sector" : this.placementsForm.value.sector,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.placementsForm.value._id,
        "seohidden" : this.placementsForm.value.seohidden
      };
        // console.log(data1);     
        this.http.put<any>(this.api_endpoint+'/placements/', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/recruiters/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
